<template>
  <li flex items-start gap-12px>
    <UnoIcon i-fubex-check text-accent-500 dark:text-accent-300 h-18px w-18px flex-none mt-4px />
    <slot />
  </li>
</template>
